export { default } from './ForecastGraphSwellSpectra';
